import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentUser: null,
    externalProvider: null,
    currentFile: null,
    currentChain: null,
    remoteConfig: null,
    currentTheme: null,
    chainsToSign: null
  },

  getters: {
    isSignedIn: state => !!state.currentUser,
    hasRole: state => role => state.currentUser && state.currentUser.roles.includes(role)
  },

  mutations: {
    setCurrentUser(state, currentUser) {
      if (currentUser && currentUser.roles) {
        currentUser.roles.push('user')
      }
      state.currentUser = currentUser
    },

    removeCurrentUser(state) {
      state.currentUser = null
    },

    setExternalProviderDetails(state, provider) {
      state.externalProvider = provider
    },

    removeExternalProviderDetails(state) {
      state.externalProvider = null
    },

    setCurrentFile(state, newFile) {
      state.currentFile = newFile
    },
    removeCurrentFile(state) {
      state.currentFile = null
    },
    setCurrentChain(state, newFile) {
      state.currentChain = newFile
    },
    removeCurrentChain(state) {
      state.currentChain = null
    },
    setRemoteConfig(state, config) {
      state.remoteConfig = config
    },
    removeRemoteConfig(state) {
      state.remoteConfig = null
    },

    setCurrentTheme(state, currentTheme) {
      state.currentTheme = currentTheme
    },
    removeCurrentTheme(state) {
      state.currentTheme = null
    },
    setChainsToSign(state, chains) {
      state.chainsToSign = [...chains]
    },
    removeChainsToSign(state) {
      state.chainsToSign = null
    }
  },

  plugins: [
    createPersistedState({
      paths: ['externalProvider'] // Persist only this property
    })
  ]
})

export default store
